module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp13_6005.571828c0.png";